import { lazy } from "react"
import type { Doughnut as DoughnutCmp } from "./Doughnut"

export const Doughnut = lazy(() =>
  import("./Doughnut").then((module) => ({
    default: module.Doughnut,
  })),
) as typeof DoughnutCmp
